import React, { useEffect, useState } from "react";
import TopNav from "../layouts/TopNav";
import { useLocation, Link, useNavigate } from "react-router-dom";
import "../Styles/genratedslip.css";
import html2pdf from "html2pdf.js";
import { BsPencil } from "react-icons/bs";
import logo from "../asset/Image/logo-.png";
import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";
import ReLoginModal from "../components/ReLoginModal";
import api from "../util/axios";

const ContinueGeneratingSlip = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isReprint, setIsReprint] = useState(false)

  type Requisition = {
    _id: string;
    approvalNumber: string;
    availableToBook: number;
    customer: {
      _id: string;
      businessName: string;
    };
    itemId: string;
    itemName: string;
    quantity: number;
    quantityToLoad: number;
    totalCost: number;
    unitPrice: number;
  };

  const details = location.state;
  const validObjectId = (id: string) => /^[0-9a-fA-F]{24}$/.test(id) ? id : null;

  const requiData = details?.requisitions?.map((val: any) => ({
    ...val,
    _id: validObjectId(val._id),
  })) || [];

  const [loading, setLoading] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [invoiceComplete, setInvoiceComplete] = useState(false);

  interface Invoice {
    loader: string;
    supplyLocation: string;
    destination: string;
    ullager: string;
    started: string;
    completed: string;
    meterBefore: string;
    meterAfter: string;
    Cfirst: string;
    Csecond: string;
    Cthird: string;
    Cfourth: string;
    Cfifth: string;
    Csixth: string;
    Cseventh: string;
    Ufirst: string;
    Usecond: string;
    Uthird: string;
    Ufourth: string;
    Ufifth: string;
    Usixth: string;
    Useventh: string;
    approvalNumber: string;
    customer: string;
    businessName: string;
    itemName: string;
    itemId: string;
    description: string;
    quantity: string;
    unitPrice: string;
    totalCost: string;
    quantityToLoad: string;
    quantityLoaded: string;
    availableToBook: string;
    _id: string;
    invoiced: string;
    capacity: string;
    // plateNumber: string;
    truckNumber: string;
    driver: string;
    driverNum: string;
  }

  const [inv, setInv] = useState<Invoice>({
    loader: "",
    supplyLocation: "First Royal Oil Nigeria Limited",
    destination: "",
    ullager: "",
    started: "",
    completed: "",
    meterBefore: "",
    meterAfter: "",
    Cfirst: "",
    Csecond: "",
    Cthird: "",
    Cfourth: "",
    Cfifth: "",
    Csixth: "",
    Cseventh: "",
    Ufirst: "",
    Usecond: "",
    Uthird: "",
    Ufourth: "",
    Ufifth: "",
    Usixth: "",
    Useventh: "",
    approvalNumber: "",
    customer: "",
    businessName: "",
    itemName: "",
    itemId: "",
    description: "",
    quantity: "",
    unitPrice: "",
    totalCost: "",
    quantityToLoad: "",
    quantityLoaded: "",
    availableToBook: "",
    _id: "",
    invoiced: "true",
    capacity: "",
    // plateNumber: "",
    truckNumber: details?.truckNumber || "",
    driver: details?.selectedDriverDetails?.driver || "",
    driverNum: " ",
  });

  const [currentDateTime, setCurrentDateTime] = useState("");
  const [reLogin, setReLogin] = useState(false);

  // console.log("checking", details);
  // const requiData = details?.requisitions?.map((val: any) => val);

  const generatePDF = () => {
    const slipElement = document.querySelector(".generatedSlip");
    const printButtons = document.querySelector(".print");

    if (slipElement) {
      // Hide print buttons before generating the PDF
      if (printButtons) (printButtons as HTMLElement).style.display = "none";

      const pdfOptions = {
        margin: 2,
        filename: "generated_slip.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "landscape" },
      };

      html2pdf()
        .from(slipElement)
        .set(pdfOptions)
        .save()
        .finally(() => {
          // Show print buttons again after generating the PDF
          if (printButtons) (printButtons as HTMLElement).style.display = "block";
        });
    }
  };

  useEffect(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    const hours = String(today.getHours()).padStart(2, "0");
    const minutes = String(today.getMinutes()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}T${hours}:${minutes}`;
    setCurrentDateTime(formattedDate);
  }, []);

  const token = window.localStorage.getItem("token");

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const handleChange = ({ target: { name, value } }: any) => {
    setInv((prevInv) => {
      let updatedInv = { ...prevInv, [name]: value };

      if (name === 'meterBefore' || name === 'quantityLoaded') {
        const meterBefore = parseFloat(updatedInv.meterBefore || '0');
        const quantityLoaded = parseFloat(updatedInv.quantityLoaded || '0');

        updatedInv.meterAfter = (meterBefore + quantityLoaded).toFixed(2);
      }

      return updatedInv;
    });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();


    const quantityToLoad = details?.requisitions?.reduce((acc: any, req: any) => acc + req.quantityToLoad, 0);

    const totalCompartmentVolume = [
      inv.Cfirst,
      inv.Csecond,
      inv.Cthird,
      inv.Cfourth,
      inv.Cfifth,
      inv.Csixth,
      inv.Cseventh
    ].reduce((acc, val) => acc + (parseFloat(val) || 0), 0);

    if (totalCompartmentVolume !== quantityToLoad) {
      Swal.fire({
        title: 'Error!',
        text: `Total value in compartments (${totalCompartmentVolume}) should be equal to Quantity To Be Loaded (${quantityToLoad}).`,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: 'red',
        confirmButtonText: 'Try Again',
      });
      return;
    }


    if (Number(inv.quantityLoaded) !== quantityToLoad) {
      Swal.fire({
        title: 'Error!',
        text: `Quantity Loaded (${inv.quantityLoaded}) must be equal to Quantity To Load (${quantityToLoad}).`,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: 'red',
        confirmButtonText: 'Try Again',
      });
      return;
    }

    const meterBefore = parseFloat(inv.meterBefore);
    const meterAfter = parseFloat(inv.meterAfter);
    const quantityLoaded = parseFloat(inv.quantityLoaded);

    if (meterAfter - meterBefore !== quantityLoaded) {
      Swal.fire({
        title: 'Error!',
        text: `Difference between Meter After (${meterAfter}) and Meter Before (${meterBefore}) should be equal to Quantity Loaded (${quantityLoaded}).`,
        icon: 'error',
        showCancelButton: false,
        confirmButtonColor: 'red',
        confirmButtonText: 'Try Again',
      });
      return;
    }

    setLoading(true);

    api.patch(
      `/loading-slip/${details?._id}`,
      {
        supplyLocation: inv.supplyLocation,
        destination: inv.destination,
        loader: inv.loader,
        ullager: inv.ullager,
        loadingTime: {
          started: inv.started,
          completed: inv.completed,
        },
        meterBefore: inv.meterBefore,
        meterAfter: inv.meterAfter,
        compartmentNo: {
          first: inv.Cfirst,
          second: inv.Csecond,
          third: inv.Cthird,
          fourth: inv.Cfourth,
          fifth: inv.Cfifth,
          sixth: inv.Csixth,
          seventh: inv.Cseventh,
        },
        ullage: {
          first: inv.Ufirst,
          second: inv.Usecond,
          third: inv.Uthird,
          fourth: inv.Ufourth,
          fifth: inv.Ufifth,
          sixth: inv.Usixth,
          seventh: inv.Useventh,
        },
        requisitions: requiData.map((req: any) => ({
          approvalNumber: req.approvalNumber,
          availableToBook: req.availableToBook,
          customer: req.customer,
          businessName: req.customer._id,
          itemId: req.itemId,
          itemName: req.itemName,
          quantity: req.quantity,
          quantityLoaded: inv.quantityLoaded,
          quantityToLoad: req.quantityToLoad,
          totalCost: req.totalCost,
          unitPrice: req.unitPrice,
          _id: req._id,
        })),
        transporter: details?.selectMvt,
        truckNumber: inv.truckNumber,
        driver: details?.transporter === 'SELF COLLECTION' ? inv.driver : details?.selectedDriverDetails?.driver,
        capacity: inv.capacity,
        // plateNumber: inv.plateNumber,
        invoiced: invoiceComplete,
      },
      { headers: headers }
    )
      .then((res) => {
        setLoading(false);
        Swal.fire({
          title: 'Success!',
          text: `${res.data.message}`,
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: 'green',
          confirmButtonText: 'Continue',
        });
        setTimeout(() => {
          navigate('/dashboard/invoicetable');
        }, 3000);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response.data.message === 'jwt expired' || err.response.data.message === 'jwt malformed') {
           
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        Swal.fire({
          title: 'Error!',
          text: `${err.response.data.message}`,
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: 'red',
          confirmButtonText: 'Try Again',
        });
      });
  };






  //   const businessName = details?.requisitions?.map().customer.businessName || "Business Name Unavailable"
  const loadingNumber = details?.loadingNumber || "N/A"
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const hours = String(today.getHours()).padStart(2, "0");
  const minutes = String(today.getMinutes()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;

  // console.log(num)
  // console.log("Yoooo",details)

  return (
    <div className="board">
      {reLogin ? <ReLoginModal /> : null}
      <TopNav title="Loading Slip" />
      <form onSubmit={handleSubmit} className="generatedSlip">
        <span
          onClick={() => setIsEditing(!isEditing)}
          className={`editText ${isEditing ? "" : "opaque"}`}
        >
          <BsPencil /> Edit
        </span>
        <div className="topDetails pb-2">
          <h2>

            {details?.requisitions?.map(
              (num: any) => num.customer.businessName
            )}
            {/* Business Name */}
          </h2>

          <p>Loading slip No: {details?.loadingNumber} </p>
        </div>

        <table>
          <tr className="compa">
            <td colSpan={2}>
              Supply Location: First Royal Oil Nigeria Limited
              <input
                // readOnly={!isEditing}
                // className={isEditing ? "editable" : ""}
                type="text"
                name="supplyLocation"
                value={inv.supplyLocation || "First Royal oil Nigeria Limited"}
                onChange={handleChange}
              />
              {/* {details?.supplyLocation} */}
            </td>
            <td colSpan={5}>
            </td>
            <td colSpan={3} rowSpan={2}>
              <img className="w-22 h-16" src={logo} alt="" />
            </td>
          </tr>
          <tr className="compa">
            <td colSpan={2}>
              Approval No: { }
              {details?.requisitions?.map((num: any) => num.approvalNumber)}
            </td>
            <td colSpan={5}>
              Product:
              {details?.requisitions?.map((pro: any) => pro.itemName)}
            </td>
          </tr>
          <tr className="compa">
            <td colSpan={4}>Customer: {details?.requisitions?.map(
              (num: any) => num.customer.businessName
            )}
            </td>

            <td colSpan={3}>
              QTY TO BE LOADED:
              {details?.requisitions?.map((num: any) => num.quantityToLoad)}
            </td>
            <td rowSpan={3} colSpan={2}>
              SPECIFY TANK OR SUB INVENTORY PRODUCT WAS LOADED FROM BELOW
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                onChange={handleChange}
              />
            </td>
            {/* <td rowSpan={7} colSpan={3}>
              Color
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                onChange={handleChange}
              />
            </td> */}
          </tr>

          <tr className="compa">
            <td className="destination" colSpan={4}>Destination:
              {/* {details?.supplyLocation} */}
              <input
                // required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="destination"
                value={inv.destination}
                onChange={handleChange}
              />
            </td>

            <td colSpan={3}>
              QTY LOADED:<span className="require_star">*</span>
              {details?.requisitions?.map((num: any) => num.quantityToLoaded)}
              <input
                required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="number"
                name="quantityLoaded"
                value={inv.quantityLoaded}
                onChange={handleChange}
              />
            </td>

          </tr>
          <tr className="compa">
            <td colSpan={4}>
              TIME OF BRV ARRIVAL AT IN-GATE
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="time"
                onChange={handleChange}
              />
            </td>

            <td colSpan={3}>
              METER BEFORE:<span className="require_star">*</span>
              <input
                required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="number"
                name="meterBefore"
                value={inv.meterBefore}
                onChange={handleChange}
              />
            </td>

          </tr>

          <tr className="compa">
            <td rowSpan={2} colSpan={1}>
              SECURITY ALLOW BRV
            </td>

            <td colSpan={5}>
              Driver's Name: <span className="require_star">*</span>
              <input
                required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="driver"
                value={inv.driver}
                onChange={handleChange}
              />
            </td>
            <td colSpan={3}>
              METER AFTER:
              <input
                // required
                // readOnly={!isEditing}
                // className={isEditing ? "editable" : ""}
                type="number"
                name="meterAfter"
                value={inv.meterAfter}
                readOnly
                className="read-only"
              // onChange={handleChange}
              />
            </td>

          </tr>
          <tr className="compa">

            <td colSpan={5}>
              Loader's Name: <span className="require_star">*</span>
              <input
                required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="loader"
                value={inv.loader}
                onChange={handleChange}
              />
            </td>
            <td colSpan={3}>
              TIME LOADING STARTED:
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                name="started"
                value={inv.started || currentDateTime}
                onChange={handleChange}
                type="datetime-local"
              />
            </td>



          </tr>
          <tr className="compa">
            <td colSpan={1}>
              Capacity:
              <input

                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="capacity"
                value={inv.capacity}
                onChange={handleChange}
              />
            </td>
            <td colSpan={4}>
              Truck Number: {" "}
              {inv.truckNumber}
              <input
                required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="truckNumber"
                value={inv.truckNumber}
                onChange={handleChange}
              />
            </td>
            <td colSpan={5}>
              TIME LOADING ENDED:
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                name="completed"
                value={inv.completed || currentDateTime}
                onChange={handleChange}
                type="datetime-local"
              />
            </td>


          </tr>
          <tr className="compa">
            {/* <td colSpan={4}>
              Driver's number <span className="require_star">*</span>
              <input
                required
               readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="driverNum"
                value={inv.driverNum}
                onChange={handleChange}
              />
            </td> */}

          </tr>
          <tr className="compa">
            <td colSpan={4}>
              ULLAGE’S NAME <span className="require_star">*</span>
              <input
                required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="ullager"
                value={inv.ullager}
                onChange={handleChange}
              />
            </td>
            <td colSpan={3}>
              ULLAGE TIME
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                name="completed"
                value={inv.completed || currentDateTime}
                onChange={handleChange}
                type="datetime-local"
              />
            </td>
            <td colSpan={3}>
              C OF Q NO
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="number"
              />
            </td>
          </tr>
          <tr className="compa volumeSpace">
            <td>COMPARTMENT NO:</td>
            <td>1</td>
            <td>2</td>
            <td>3</td>
            <td>4</td>
            <td>5</td>
            <td>6</td>
            <td>7</td>
            <td>
              BATCH
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="number"
              />
            </td>
          </tr>
          <tr className="compa rowSpace">
            <td colSpan={1}>COMPARTMENT VOL IN LTR: <span className="require_star">*</span></td>
            <td rowSpan={1}>
              <input
                required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Cfirst"
                value={inv.Cfirst}
                onChange={handleChange}
              />
            </td>
            <td>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Csecond"
                value={inv.Csecond}
                onChange={handleChange}
              />
            </td>
            <td >
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Cthird"
                value={inv.Cthird}
                onChange={handleChange}
              />
            </td>
            <td>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Cfourth"
                value={inv.Cfourth}
                onChange={handleChange}
              />
            </td>
            <td >
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Cfifth"
                value={inv.Cfifth}
                onChange={handleChange}
              />
            </td>
            <td >
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Csixth"
                value={inv.Csixth}
                onChange={handleChange}
              />
            </td>
            <td >
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Cseventh"
                value={inv.Cseventh}
                onChange={handleChange}
              />
            </td>
            <td rowSpan={1} colSpan={1}>
              S.G
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
              />
            </td>
          </tr>
          <tr className="compa">
            <td colSpan={1}>ULLAGE <span className="require_star">*</span></td>
            <td colSpan={1}>
              <input
                required
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Ufirst"
                value={inv.Ufirst}
                onChange={handleChange}
              />
            </td>
            <td colSpan={1}>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Usecond"
                value={inv.Usecond}
                onChange={handleChange}
              />
            </td>
            <td colSpan={1}>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Uthird"
                value={inv.Uthird}
                onChange={handleChange}
              />
            </td>
            <td colSpan={1}>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                name="Ufourth"
                value={inv.Ufourth}
                type="text"
                onChange={handleChange}
              />
            </td>
            <td colSpan={1}>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Ufifth"
                value={inv.Ufifth}
                onChange={handleChange}

              />
            </td>
            <td colSpan={1}>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Usixth"
                value={inv.Usixth}
                onChange={handleChange}

              />
            </td>
            <td colSpan={1}>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
                name="Useventh"
                value={inv.Useventh}
                onChange={handleChange}

              />
            </td>
            <td colSpan={3}>
              ACTUAL TEMP
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
              />
            </td>
          </tr>
          <tr className="compa">
            <td colSpan={1}>Seal</td>
            <td colSpan={2}>
              Seal No
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="number"
              />
            </td>
            <td colSpan={4}>
              invoice generated time:
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                name="started"
                value={inv.started || currentDateTime}
                onChange={handleChange}
                type="datetime-local"
              />
            </td>
            <td colSpan={4}>brv out time</td>
          </tr>
          <div className="waterMark">
            <span>{details?.requisitions?.map((pro: any) => pro.itemName)}</span>
          </div>
          <tr className="compa">
            <td colSpan={2}>Y/N</td>
            <td colSpan={2}>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
              />
            </td>
            <td colSpan={4}>
              invoice Signed time:
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                name="completed"
                value={inv.completed || currentDateTime}
                onChange={handleChange}
                type="datetime-local"
              />
            </td>
            <td colSpan={4}>
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
              />
            </td>
          </tr>

          <tr>
            <td className="pb-5" colSpan={2}>
              gate entry authorisation
              <input
                readOnly={!isEditing}
                className={isEditing ? "editable" : ""}
                type="text"
              />
            </td>
            {/* <td colSpan={1}></td> */}

            <td colSpan={8}>
              <table>
                <tr>
                  <th>signature</th>
                  <th>SLIP DATE</th>
                  <th>{formattedDate}</th>
                </tr>
                <tr>
                  <td></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
        <p className="w-full text-sm text-blue-800">generated by {details.staff.name}</p>

        {isEditing ? (
          <div
            className="print"
            style={{
              justifyContent: "flex-left",
              flexDirection: "column",
              alignItems: "flex-left",
            }}
          >
            <div className="checks">
              <input
                required
                type="checkbox"
                checked={invoiceComplete}
                onChange={() => setInvoiceComplete(!invoiceComplete)}
              />
              <span>
                Invoice Complete (Click only when you fill all the input)
              </span>
            </div>
            <button type="submit" className="catBtn11">
              {loading ? (
                <CircularProgress
                  style={{
                    color: "#fff",
                    backgroundColor: "transparent",
                    // width: "20px",
                    // height: "20px",
                  }}
                />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        ) : null}



        <div className="print">
          <button type="button" onClick={generatePDF}>
            Print Slip
          </button>
          <Link to="/dashboard/notinvoiced">close</Link>
        </div>
      </form>
    </div>
  );
};

export default ContinueGeneratingSlip;

// 